"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setLogEntryHiddenOutputDtoSchema = exports.setLogEntryHiddenInputDtoSchema = exports.deleteContinuityForFindingOutputDtoSchema = exports.deleteContinuityForFindingInputDtoSchema = exports.appendContinuityForFindingOutputDtoSchema = exports.appendContinuityForFindingInputDtoSchema = exports.appendActivityOutputDtoSchema = exports.appendUpdateForFindingInputDtoSchema = exports.appendNoteForFindingInputDtoSchema = exports.appendNoteForAssertionResultsInputDtoSchema = exports.appendNoteForAssertionResultInputDtoSchema = exports.listActivityForAssertionResultOutputDtoSchema = exports.activityEntryDtoSchema = exports.listActivityForAssertionResultInputDtoSchema = void 0;
const zod_1 = require("zod");
const cadstrom_shared_1 = require("@cadstrom/cadstrom-shared");
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const enum_names_js_1 = require("./enum-names.js");
const query_builder_helpers_js_1 = require("./query-builder-helpers.js");
const severitySchema = sigma_engine_shared_1.RequirementsV2.RequirementSeveritySchema;
const workflowStateSchema = sigma_engine_shared_1.RequirementsV2.RequirementWorkflowStateSchema;
exports.listActivityForAssertionResultInputDtoSchema = zod_1.z.object({
    assertionResultId: zod_1.z.string(),
    limit: zod_1.z.number().min(1).max(500).optional(),
    cursor: zod_1.z.string().optional(),
    columnFilters: cadstrom_shared_1.QueryBuilder.createColumnFilterZodSchema(cadstrom_shared_1.RequirementsV2.requirementLogEntryFilterSchema).optional(),
    columnFilterLogicOperator: query_builder_helpers_js_1.columnFilterLogicOperatorSchema.optional(),
    sort: cadstrom_shared_1.QueryBuilder.createSortZodSchema(cadstrom_shared_1.RequirementsV2.requirementLogEntryFilterSchema).optional(),
});
exports.activityEntryDtoSchema = zod_1.z.object({
    id: zod_1.z.string(),
    buildId: zod_1.z.string(),
    entryType: sigma_engine_shared_1.RequirementsV2.LogEntryTypeSchema,
    authorUserId: zod_1.z.string().nullable(),
    authorRole: sigma_engine_shared_1.RequirementsV2.LogEntryAuthorRoleSchema,
    severity: severitySchema.nullable(),
    severityName: enum_names_js_1.requirementSeverityNameSchema
        .nullable()
        .describe('Name of the numeric `severity`, e.g. `Warning`; null when `severity` is null.'),
    workflowState: workflowStateSchema.nullable(),
    workflowStateName: enum_names_js_1.requirementWorkflowStateNameSchema
        .nullable()
        .describe('Name of the numeric `workflowState`, e.g. `Unreviewed`; null when `workflowState` is null.'),
    message: zod_1.z.string().nullable(),
    description: zod_1.z.string().nullable(),
    hiddenAt: zod_1.z.date().nullable(),
    hiddenByUserId: zod_1.z.string().nullable(),
    createdAt: zod_1.z.date(),
    sourceSystem: zod_1.z.string().nullable(),
    sourceRunId: zod_1.z.string().nullable(),
    sourceResultKey: zod_1.z.string().nullable(),
    deterministicValidationPayload: zod_1.z.unknown().nullable().optional(),
    aiValidationPayload: zod_1.z.unknown().nullable().optional(),
    notePayload: sigma_engine_shared_1.RequirementsV2.noteLogPayloadSchema.nullable(),
});
exports.listActivityForAssertionResultOutputDtoSchema = zod_1.z.object({
    entries: exports.activityEntryDtoSchema.array(),
    hasNextPage: zod_1.z.boolean(),
    nextCursor: zod_1.z.string().nullable(),
});
const baseNoteFields = {
    message: zod_1.z.string().optional().describe('Plain-text body of the note.'),
    description: zod_1.z.string().optional().describe('Long-form description; renders alongside `message` in the timeline.'),
    workflowState: workflowStateSchema
        .optional()
        .describe(`Workflow-state contribution from this note (acknowledged | ignored | fixed). Any author role may set this; the projection merge applies it as the latest non-null contribution. One of: ${(0, enum_names_js_1.describeEnumValues)(sigma_engine_shared_1.RequirementsV2.RequirementWorkflowState)}`),
    severity: severitySchema
        .optional()
        .describe(`Severity contribution from this note. Any author role may set this; the projection merge applies it as the latest non-null contribution. One of: ${(0, enum_names_js_1.describeEnumValues)(sigma_engine_shared_1.RequirementsV2.RequirementSeverity)}`),
    notePayload: sigma_engine_shared_1.RequirementsV2.noteLogPayloadSchema
        .optional()
        .describe('Structured note payload. `user-note` carries the markdown body; validated against the closed note-payload union.'),
};
exports.appendNoteForAssertionResultInputDtoSchema = zod_1.z.object({
    assertionResultId: zod_1.z.string(),
    ...baseNoteFields,
});
exports.appendNoteForAssertionResultsInputDtoSchema = zod_1.z.object({
    assertionResultIds: zod_1.z
        .array(zod_1.z.string())
        .min(1)
        .describe('Assertion-result ids that share the new note. Used to acknowledge / ignore / mark-fixed a slug-grouped AR (e.g. all members of `net:NET_FOO`) with a single log entry and N link rows. All ids must belong to the same build.'),
    ...baseNoteFields,
});
exports.appendNoteForFindingInputDtoSchema = zod_1.z.object({
    findingId: zod_1.z.string(),
    buildId: zod_1.z
        .string()
        .optional()
        .describe("Revision to attribute this entry to. Must be one the finding already exhibits in — pin it there with `appendContinuityForFinding` first. Omit to attribute the entry to the finding's most-recently-touched revision."),
    ...baseNoteFields,
});
exports.appendUpdateForFindingInputDtoSchema = zod_1.z.object({
    findingId: zod_1.z.string(),
    buildId: zod_1.z
        .string()
        .optional()
        .describe("Revision to attribute this entry to. Must be one the finding already exhibits in — pin it there with `appendContinuityForFinding` first. Omit to attribute the entry to the finding's most-recently-touched revision."),
    message: zod_1.z.string().optional().describe('Plain-text body of the update.'),
    description: zod_1.z.string().optional().describe('Long-form description rendered alongside `message`.'),
    workflowState: workflowStateSchema
        .optional()
        .describe(`Workflow-state contribution from this update. One of: ${(0, enum_names_js_1.describeEnumValues)(sigma_engine_shared_1.RequirementsV2.RequirementWorkflowState)}`),
    severity: severitySchema
        .optional()
        .describe(`Severity contribution from this update. One of: ${(0, enum_names_js_1.describeEnumValues)(sigma_engine_shared_1.RequirementsV2.RequirementSeverity)}`),
});
exports.appendActivityOutputDtoSchema = zod_1.z.object({
    logEntryId: zod_1.z.string(),
});
exports.appendContinuityForFindingInputDtoSchema = zod_1.z.object({
    findingId: zod_1.z.string(),
    buildId: zod_1.z
        .string()
        .describe('Revision to pin the finding into, so it exhibits there. May be earlier or later than its current one.'),
    disposition: sigma_engine_shared_1.RequirementsV2.FindingContinuityDispositionSchema.optional().describe(`What the pin asserts about the finding in this revision. \`reproduced\` (the default) leaves the finding's severity as it stands; \`resolved\` records it as verified absent and sets severity to \`Pass\`. Neither changes the workflow state, which stays with the customer to acknowledge. One of: ${(0, enum_names_js_1.describeEnumValues)(sigma_engine_shared_1.RequirementsV2.FindingContinuityDisposition)}`),
    severity: severitySchema
        .optional()
        .describe(`Severity this pin contributes, for recording that the finding reproduces at a different severity than before — including a return to failing after an earlier \`resolved\` pin. Only valid with \`reproduced\`, and never \`Pass\`; omit it to carry the finding's current severity across unchanged. A \`resolved\` pin sets \`Pass\` on its own and rejects this field. One of: ${(0, enum_names_js_1.describeEnumValues)(sigma_engine_shared_1.RequirementsV2.RequirementSeverity)}`),
    reason: zod_1.z.string().optional().describe('Why the finding was judged to continue into this revision.'),
});
exports.appendContinuityForFindingOutputDtoSchema = zod_1.z.object({
    logEntryId: zod_1.z.string(),
    buildId: zod_1.z.string(),
    created: zod_1.z.boolean().describe('False when an identical pin already existed and no entry was written.'),
});
exports.deleteContinuityForFindingInputDtoSchema = zod_1.z.object({
    findingId: zod_1.z.string(),
    buildId: zod_1.z.string().describe('Revision to withdraw the finding from.'),
});
exports.deleteContinuityForFindingOutputDtoSchema = zod_1.z.object({
    deletedLogEntryIds: zod_1.z.array(zod_1.z.string()).describe('Empty when the finding was not pinned to this revision.'),
    stillExhibits: zod_1.z
        .boolean()
        .describe('True when other activity in the revision keeps the finding exhibiting there regardless.'),
});
exports.setLogEntryHiddenInputDtoSchema = zod_1.z.object({
    logEntryId: zod_1.z
        .string()
        .describe('Id of the log entry to hide or reveal. Hiding withdraws every projection field the entry contributed; revealing restores them. The row is never destroyed, so the original contribution stays recoverable.'),
    hidden: zod_1.z.boolean().describe('Desired hidden state. Setting the current state is a no-op.'),
});
exports.setLogEntryHiddenOutputDtoSchema = zod_1.z.object({
    hidden: zod_1.z.boolean(),
});
//# sourceMappingURL=activity.dto.js.map